import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';

/**
 * Draggable Modal Wrapper
 *
 * Makes mat-dialog modals draggable from designated header elements only.
 * This allows text selection in modal content while preserving drag functionality.
 *
 * Usage:
 * ```html
 * <app-draggable-modal-wrapper>
 *   <h2 mat-dialog-title modal-drag-handle>My Modal Title (draggable)</h2>
 *   <div mat-dialog-content>Content here is NOT draggable</div>
 * </app-draggable-modal-wrapper>
 * ```
 *
 * The `modal-drag-handle` attribute marks which element serves as the drag handle.
 * Only elements with this attribute will be draggable - all other content allows
 * normal text selection and interaction.
 *
 * Note: Modals without `modal-drag-handle` are not draggable at all.
 */
@Component({
    selector: 'app-draggable-modal-wrapper',
    standalone: true,
    imports: [DragDropModule],
    templateUrl: './draggable-modal-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./draggable-modal-wrapper.component.scss'],
})
export class DraggableModalWrapperComponent {}
